import { render } from "./SSDBalancesView.vue?vue&type=template&id=bfb431c4&scoped=true"
import script from "./SSDBalancesView.vue?vue&type=script&lang=js"
export * from "./SSDBalancesView.vue?vue&type=script&lang=js"

import "./SSDBalancesView.vue?vue&type=style&index=0&id=bfb431c4&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb431c4"]])

export default __exports__